<template>
  <div>
    <v-container fluid>
      <v-row class="mt-5 mb-5">
        <v-col cols="12" sm="6" md="3">
          <v-card class="mx-auto" max-width="344">
            <v-card-text>
              <div>Total Sales</div>
              <p class="text-h4 text--accent">£ {{ this.sales.toFixed(2) }}</p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-card class="mx-auto" max-width="344">
            <v-card-text>
              <div>Total Receipts</div>
              <p class="text-h4 text--accent">
                £ {{ this.receipts.toFixed(2) }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-card class="mx-auto" max-width="344">
            <v-card-text>
              <div>Total Credits</div>
              <p class="text-h4 text--accent">
                £ {{ this.credits.toFixed(2) }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-card class="mx-auto" max-width="344">
            <v-card-text>
              <div>Total Outstanding</div>
              <p class="text-h4 text--accent">
                £ {{ this.balance.toFixed(2) }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-card class="elevation-11">
        <v-card-title class="accent">
          <h3>Most Recent Invoices</h3>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            outlined
            dense
            hide-details
          ></v-text-field>
          <v-data-table
            v-if="this.ledgerKey.length === 0"
            :loading="loading"
            :search="search"
            :headers="adminHeader"
            :items="invoices"
            item-key="invkey"
            class="mt-4 elevation-1"
            loading-text="Retrieving invoices... please wait"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon medium @click="downloadInvoice(item)"
                >mdi-download</v-icon
              >
            </template>
          </v-data-table>
          <v-data-table
            v-if="this.ledgerKey.length > 0"
            :loading="loading"
            :search="search"
            :headers="clientHeader"
            :items="invoices"
            item-key="invkey"
            class="mt-4 elevation-1"
            loading-text="Retrieving invoices... please wait"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon medium @click="downloadInvoice(item)"
                >mdi-download</v-icon
              >
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import AdminLayout from "@/layouts/AdminLayout.vue";
import moment from "moment";
import api from "../services/axiosconfig";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { aejImgData, iataImgData } from "../services/logos";
import store from "../store";

export default {
  data() {
    return {
      search: "",
      loading: false,
      adminHeader: [
        { text: "Inv No.", align: "start", value: "invoicenum" },
        { text: "Inv Date", align: "start", value: "invoicedate" },
        { text: "Customer", align: "start", value: "customer" },
        { text: "GTS/TR No.", align: "start", value: "agencyref" },
        { text: "Destination", align: "start", value: "finaldest" },
        { text: "Departure", align: "start", value: "depdate" },
        { text: "Locator", align: "start", value: "locator" },
        { text: "Passenger", align: "start", value: "passenger" },
        { text: "Amount (GBP)", align: "end", value: "costings" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      clientHeader: [
        { text: "Inv No.", align: "start", value: "invoicenum" },
        { text: "Inv Date", align: "start", value: "invoicedate" },
        { text: "GTS/TR No.", align: "start", value: "agencyref" },
        { text: "Destination", align: "start", value: "finaldest" },
        { text: "Departure", align: "start", value: "depdate" },
        { text: "Locator", align: "start", value: "locator" },
        { text: "Passenger", align: "start", value: "passenger" },
        { text: "Amount (GBP)", align: "end", value: "costings" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      ledgerKey: 0,
      invoices: [],
      startDate: new Date(),
      endDate: new Date(),
      sales: 0,
      receipts: 0,
      credits: 0,
      balance: 0,

      caption: "Business & Leisure Travel Management",
      address: "No.35 St.John's Road, Isleworth, Middlesex TW7 6NY",
      telno: "Tel No. 020 8560 2458",
      email: "Email: accounts@aejtravels.co.uk",
      notes: [
        "IMPORTANT NOTICE : This is a special fare ticket and may be non refundable. Please check all conditions.Cancellations and changes may be restricted so check if in doubt. Please ensure that you have valid travel documents & visas for your journey. Please reconfirm all flights at least 72 hours before departure, failure to do so may result in cancellation of your booking. Thank you.",
      ],
    };
  },

  created() {
    this.$emit(`update:layout`, AdminLayout);
    this.getCurrentLedgerKey();
    this.calcDates();
    this.getInvoices();
  },

  methods: {
    getTitle() {
      return moment(this.startDate).format("MMMM, YYYY");
    },
    async getCurrentLedgerKey() {
      this.ledgerKey = localStorage.getItem("LEDG_KEY");
    },

    dateFormat(dateString) {
      return moment(new Date(dateString)).format("DD-MM-YYYY");
    },

    calcDates() {
      // this.startDate = moment().startOf("month").format("YYYY-MM-DD");
      this.endDate = moment().endOf("month").format("YYYY-MM-DD");
      this.startDate = moment()
        .subtract(2, "months")
        .startOf("month")
        .format("YYYY-MM-DD");
    },

    async getInvoices() {
      this.invoices = [];
      this.pdfdata = [];
      try {
        let response = "";
        this.loading = true;
        if (this.$store.getters.dashboardInvoices === null) {
          if (this.ledgerKey.length > 0) {
            response = await api.post("/aejmis/api/invoices", {
              startdate: this.startDate,
              enddate: this.endDate,
              ledgerkey: this.ledgerKey,
            });
          } else {
            response = await api.post("/aejmis/api/allinvoices", {
              startdate: this.startDate,
              enddate: this.endDate,
            });
          }
          this.pdfdata = response.data;
        } else {
          this.pdfdata = this.$store.getters.dashboardInvoices;
        }
        await store.dispatch("setInvoices", this.pdfdata);

        this.pdfdata.map(
          ({
            invkey,
            invoicenum,
            invoicedate,
            agencyref,
            bookingnum,
            bookingdate,
            finaldest,
            depdate,
            locator,
            firstname,
            lastname,
            accountref,
            costing,
            receipt,
            creditnote,
            customer,
          }) => {
            this.calcDues(costing, receipt, creditnote);
            this.invoices.push({
              customer: customer.clastname,
              invkey: invkey,
              invoicenum: invoicenum,
              invoicedate: this.dateFormat(invoicedate),
              agencyref: agencyref,
              bookingnum: bookingnum,
              bookingdate: this.dateFormat(bookingdate),
              finaldest: finaldest,
              depdate: this.dateFormat(depdate),
              locator: locator,
              passenger: `${firstname.trim()} ${lastname.trim()}`,
              accountref: accountref,
              costings: this.calcInvTotal(costing),
            });
          }
        );
        this.loading = false;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        this.loading = false;
        this.$toasted.global.optimus_error({
          message: "Could not retrieve information. Try after sometime.",
        });
      }
    },

    calcInvTotal(costings) {
      let amount = 0;
      costings.forEach((item) => {
        amount = amount + item.quantity * item.gross;
      });
      return parseFloat(amount).toFixed(2);
    },

    calcDues(costing, receipt, creditnote) {
      let invamt = 0;
      let rcptamt = 0;
      let credamt = 0;
      let balance = 0;
      costing.forEach((item) => {
        invamt = invamt + item.quantity * item.gross;
      });
      receipt.forEach((item) => {
        rcptamt =
          rcptamt +
          (item.amountpaidtype1 +
            item.amountpaidtype2 +
            item.amountpaidtype3 +
            item.amountpaidtype4 +
            item.amountpaidtype5 +
            item.amountpaidtype6 +
            item.amountpaidtype7 +
            item.amountpaidtype8);
      });

      if (creditnote != null) {
        credamt = credamt + creditnote.creditnotevalue;
      }
      this.sales = this.sales + invamt;
      this.receipts = this.receipts + rcptamt;
      this.credits = this.credits + credamt;

      balance = invamt - rcptamt - credamt;
      this.balance = this.balance + balance;
    },

    downloadInvoice(item) {
      const selectedIndex = this.invoices.indexOf(item);
      const selectedItem = this.pdfdata[selectedIndex];

      let invTotal = 0;
      let rcptAmount = 0;
      let balDue = 0;

      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      var pageWidth = doc.internal.pageSize.getWidth();
      var pageHeight = doc.internal.pageSize.getHeight();

      doc.addImage(aejImgData, "png", 10, 10);
      doc.addImage(iataImgData, "png", pageWidth - 47, 7);

      doc.setFontSize(12).text(this.caption, 10, 42);

      let addressX = pageWidth - (doc.getTextWidth(this.address) - 6);
      doc.setFontSize(10).text(this.address, addressX, 32);

      let telnoX = pageWidth - (doc.getTextWidth(this.telno) + 11);
      doc.setFontSize(10).text(this.telno, telnoX, 37);

      let emailX = pageWidth - (doc.getTextWidth(this.email) + 11);
      doc.setFontSize(10).text(this.email, emailX, 42);

      doc.setLineWidth(0.01).line(10, 46, 200, 46);

      const header = "INVOICE/CONFIRMATION";
      let headerX = (pageWidth - doc.getTextWidth(header)) / 2 - 10;
      doc.setFont("helvetica").setFontSize(16).text(header, headerX, 53);

      doc.autoTable({
        body: [
          [
            {
              content: `${selectedItem.customer.clastname}\n${selectedItem.customer.caddress1}\n${selectedItem.customer.caddress2}\n${selectedItem.customer.caddress3}\n${selectedItem.customer.cpostcode}\n`,
              styles: {
                halign: "left",
                fontSize: 10,
              },
            },

            {
              content: `Invoice No: ${
                selectedItem.invoicenum
              }\nInvoice Date: ${this.dateFormat(
                selectedItem.invoicedate
              )}\nBooking Ref: ${selectedItem.bookingnum}\nAgency Ref: ${
                selectedItem.agencyref
              }\nLocator: ${selectedItem.locator}\nFinal Destination: ${
                selectedItem.finaldest
              }`,
              styles: {
                halign: "right",
                fontSize: 10,
              },
            },
          ],
        ],
        margin: { left: 10, top: 55 },
        theme: "plain",
      });

      // Ticket Details
      let tickets = [];
      selectedItem.costing.forEach((costItem) => {
        costItem.ticket.forEach((ticketItem) => {
          tickets.push(
            new Array(
              ticketItem.adchinfcon,
              ticketItem.passengername,
              ticketItem.specifier,
              ticketItem.ticketnum,
              this.dateFormat(ticketItem.issuedate)
            )
          );
        });
      });

      doc.autoTable({
        head: [
          [
            {
              content: "Type",
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
            },
            {
              content: "Passenger Name",
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
            },
            {
              content: "Airline",
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
            },
            {
              content: "Ticket No.",
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
            },
            {
              content: "Issue Date",
              lineWidth: 0.1,
              lineColor: [0, 0, 0],
            },
          ],
        ],
        body: tickets,
        theme: "plain",
        tableLineWidth: 0.1,
        tableLineColor: [0, 0, 0],
      });

      // Routing Details
      let routes = [];
      selectedItem.routing.forEach((item) => {
        let printDate = true;
        const depDateYear = new Date(item.departuredate).getFullYear();
        if (depDateYear === 1900) {
          printDate = false;
        } else {
          printDate = true;
        }
        routes.push(
          new Array(
            item.from,
            item.destination,
            item.airline.trim() + item.flight.trim(),
            printDate ? item.class : "",
            printDate ? this.dateFormat(item.departuredate) : "",
            item.departuretime,
            item.arrivaltime,
            item.status
          )
        );
      });

      doc.autoTable({
        head: [
          [
            "From",
            "Destination",
            "Flight",
            "Class",
            "Date",
            "Departure",
            "Arrival",
            "Status",
          ],
        ],
        body: routes,
        theme: "plain",
        tableLineWidth: 0.1,
        tableLineColor: [0, 0, 0],
      });

      // Costing Details
      let invdetails = [];
      selectedItem.costing.forEach((item) => {
        let qty = item.quantity;
        let rate = item.priceeach;
        let salestax = item.tax;
        let value = item.quantity * item.gross;

        invTotal = invTotal + value;

        invdetails.push(
          new Array(
            {
              content: parseInt(qty),
              styles: {
                halign: "right",
              },
            },
            {
              content: item.description,
              styles: {
                halign: "left",
              },
            },
            {
              content: parseFloat(rate).toFixed(2),
              styles: {
                halign: "right",
              },
            },
            {
              content: parseFloat(salestax).toFixed(2),
              styles: {
                halign: "right",
              },
            },
            {
              content: parseFloat(value).toFixed(2),
              styles: {
                halign: "right",
              },
            }
          )
        );
      });

      doc.autoTable({
        head: [
          [
            {
              content: "Quantity",
              styles: {
                halign: "right",
              },
            },
            {
              content: "Description",
              styles: {
                halign: "left",
              },
            },
            {
              content: "Fare (GBP)",
              styles: {
                halign: "right",
              },
            },
            {
              content: "Tax (GBP)",
              styles: {
                halign: "right",
              },
            },
            {
              content: "Amount (GBP)",
              styles: {
                halign: "right",
              },
            },
          ],
        ],
        body: invdetails,
        theme: "plain",
        tableLineWidth: 0.1,
        tableLineColor: [0, 0, 0],
      });

      // Receipts
      selectedItem.receipt.forEach((item) => {
        rcptAmount = rcptAmount =
          parseFloat(item.amountpaidtype1) +
          parseFloat(item.amountpaidtype2) +
          parseFloat(item.amountpaidtype3) +
          parseFloat(item.amountpaidtype4) +
          parseFloat(item.amountpaidtype5) +
          parseFloat(item.amountpaidtype6) +
          parseFloat(item.amountpaidtype7) +
          parseFloat(item.amountpaidtype8);
      });

      balDue = invTotal - rcptAmount;

      // Totals
      doc.autoTable({
        body: [
          [
            {
              content: "INVOICE TOTAL",
              styles: {
                halign: "right",
              },
            },
            {
              content: invTotal.toFixed(2),
              styles: {
                halign: "right",
              },
            },
          ],
          [
            {
              content: "AMOUNT PAID",
              styles: {
                halign: "right",
              },
            },
            {
              content: rcptAmount.toFixed(2),
              styles: {
                halign: "right",
              },
            },
          ],
          [
            {
              content: "BALANCE",
              styles: {
                halign: "right",
              },
            },
            {
              content: balDue > 0 ? balDue.toFixed(2) : "0.00",
              styles: {
                halign: "right",
              },
            },
          ],
        ],
        theme: "plain",
        tableLineWidth: 0.1,
        tableLineColor: [0, 0, 0],
      });

      doc.setLineWidth(0.01).line(10, pageHeight - 30, 200, pageHeight - 30);

      doc
        .setFont("helvetica")
        .setFontSize(8)
        .text(this.notes, 10, pageHeight - 25, {
          align: "justify",
          maxWidth: "190",
        });

      doc.setLineWidth(0.01).line(10, pageHeight - 15, 200, pageHeight - 15);

      // Page Numbers and Total Pages
      const pageCount = doc.internal.getNumberOfPages();

      for (var i = 1; i <= pageCount; i++) {
        const pageNum = `Page ${String(i)} of ${String(pageCount)}`;
        let pageX = pageWidth - (doc.getTextWidth(pageNum) + 12);
        doc.setPage(i);
        doc
          .setFont("helvetica")
          .setFontSize(9)
          .text(pageNum, pageX, pageHeight - 10);
      }

      // Footer Content
      const footer = "VAT No. 859 0048 13";
      doc
        .setFont("helvetica")
        .setFontSize(10)
        .text(footer, 10, pageHeight - 10);

      // doc.save(`AEJ-INVOICE-${selectedItem.invoicenum}.pdf`);
      window.open(doc.output("bloburl"), "_blank");
    },
  },
};
</script>
